import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { PromptLibrary } from './components/PromptLibrary';
import { Bonuses } from './components/Bonuses';
import { Toolkit } from './components/Toolkit';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { HowItWorks } from './components/HowItWorks';
import { PromptExplainer } from './components/PromptExplainer/PromptExplainer';
import { Positioning } from './components/Positioning';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-canvas text-ink" data-id="element-0" data-mp="28s2ztflro5x1">
      <MetaPixel data-id="element-1" data-mp="23v2sz2h3ez4v" />
      <OfferBar data-id="element-2" data-mp="23ti7e2craqj5" />
      <div className="h-11" aria-hidden="true" data-id="element-3" data-mp="3ik7fqfdqo9q4" />
      <main data-id="element-4" data-mp="3ijfw82xf22g7">
        <Hero data-id="element-5" data-mp="3ijpet5g4t7bv" />
        <PainPoints data-id="element-6" data-mp="3ii4r9zs8ioni" />
        <Volumes data-id="element-7" data-mp="3mlat8v8bdto6" />
        <PromptLibrary data-id="element-8" data-mp="3mkrgdsxitvh0" />
        <Bonuses data-id="element-9" data-mp="3mjzuj9tq7c3x" />
        <Toolkit data-id="element-10" data-mp="3mjg8bgx1m1k3" />
        <Pricing data-id="element-11" data-mp="3rc9d24sih9w6" />
        <Guarantee data-id="element-12" data-mp="3rbrayrj641gc" />
        <HowItWorks data-id="element-13" data-mp="3rdar8i4tqci4" />
        <PromptExplainer data-id="element-14" data-mp="3rcsuzli5vya7" />
        <Positioning data-id="element-15" data-mp="3relvsk63foaa" />
        <FAQ data-id="element-16" data-mp="6hqffdy0fe4" />
        <FinalCTA data-id="element-17" data-mp="680frswe88f" />
      </main>
      <Footer data-id="element-18" data-mp="56nfhsbnbo2" />
    </div>;
}